import type { AssetBulkPatch, CreateAssetInput, DeleteRecordsInput, ImportAssetsInput, UpdateAssetInput } from '@shared/types';
import { showUndoToastForLastAction } from '@renderer/app/undo/undo-toast';
import { getDesktopApi } from '@renderer/lib/desktop-api';

export async function listAssets() {
  return getDesktopApi().resources.listAssets();
}

export async function getAssetById(assetId: string) {
  return getDesktopApi().resources.getAssetById(assetId);
}

export async function createAsset(payload: CreateAssetInput) {
  return getDesktopApi().resources.createAsset(payload);
}

export async function importAssets(payload: ImportAssetsInput) {
  return getDesktopApi().resources.importAssets(payload);
}

export async function updateAsset(payload: UpdateAssetInput) {
  const result = await getDesktopApi().resources.updateAsset(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function applyBulkAssetPatch(payload: AssetBulkPatch) {
  const result = await getDesktopApi().resources.applyBulkPatch(payload);
  void showUndoToastForLastAction();
  return result;
}

export async function deleteAssets(payload: DeleteRecordsInput) {
  const result = await getDesktopApi().resources.deleteAssets(payload);
  void showUndoToastForLastAction();
  return result;
}
